import type { FunctionComponent, PropsWithChildren } from 'react';
import Modal from 'react-modal';
import breakpoints from '../../../../../utils/breakpoints';
import useCurrentWidth from '../../../../commons/use-current-width/useCurrentWidth';
import topImage from '../../../../../assets/images/skip-my-box/skip-my-box-image.jpg';
import leftImage from '../../../../../assets/images/skip-my-box/skip-my-box-left-image.jpg';
import * as styles from './ModalContainer.module.css';

let modalRootElement = document.getElementById('modal-root');
if (!modalRootElement) modalRootElement = document.createElement('div');
Modal.setAppElement(modalRootElement);

interface ModalContainerType {
  closeAction: () => void;
}

const ModalContainer: FunctionComponent<PropsWithChildren<ModalContainerType>> = ({
  closeAction,
  children,
}) => {
  const currentWidth = useCurrentWidth();
  const isDesktop = currentWidth > breakpoints.medium;

  return (
    <Modal
      isOpen
      overlayClassName={styles.modalOverlay}
      className={styles.modalWrapper}
      shouldCloseOnOverlayClick
      onRequestClose={() => closeAction()}
    >
      <div className={styles.modalContainer}>
        {isDesktop && <img className={styles.leftImage} alt="fabFitFun" src={leftImage} />}
        {!isDesktop && <img className={styles.topImage} alt="fabFitFun" src={topImage} />}
        {children}
      </div>
    </Modal>
  );
};

export default ModalContainer;
